import { render, staticRenderFns } from "./NMenu.vue?vue&type=template&id=308a10e0"
import script from "./NMenu.vue?vue&type=script&lang=js"
export * from "./NMenu.vue?vue&type=script&lang=js"
import style0 from "./NMenu.vue?vue&type=style&index=0&id=308a10e0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports